<script lang="ts">
    import {
        StructuredList,
        StructuredListHead,
        StructuredListRow,
        StructuredListCell,
        StructuredListBody, 
        Select,
        SelectItem,
        Button,
        InlineLoading,
        Search
    } from "carbon-components-svelte";
    import { onMount } from "svelte";
    import {selectedTenant, userStore} from "../stores";
    import type {Tenant} from "../models/Tenant";
    import type { Requests } from "../libreries/Requests";
    import { UserModel } from "../models/UserModel";
    import User from "./User.svelte";
    import ArrowLeft20 from "carbon-icons-svelte/lib/ArrowLeft20";
    import CaretLeft16 from "carbon-icons-svelte/lib/CaretLeft16";
	import CaretRight16 from "carbon-icons-svelte/lib/CaretRight16";
    import {Helpers} from "../utilities/Helpers";

    export let requests: Requests; //Requests instance from App.svelte
    
    let tenant: Tenant;
    let isUserSelected: boolean = false;
    let promise = {};
    $: offset = 0;
    $: size = "100";
    $: query = '';
    $: usersToShow = [];
    $: isLastPage = false;

    onMount(() => {
        selectedTenant.subscribe((value) => {
            tenant = value;
            
            if(tenant){
                
                promise = getUsersToShow();
            }
        }) 
        userStore.isSelectUser.subscribe((value) => {
            isUserSelected = value;
        })          
    })

    async function getUsersToShow(){
        usersToShow = [];
        usersToShow = await requests.getUsers(tenant.id, offset, Number(size), query); 
        if(usersToShow.length > 0 && usersToShow.length === Number(size)){
            isLastPage = false;
        }else{
            isLastPage = true;
        }
    }

    function goNext(){
        offset = offset + Number(size);
        promise = getUsersToShow();
    }

    function goBack(){
        offset = offset - Number(size);
        promise = getUsersToShow();
    }

    function search(){
        offset = 0;
        promise = getUsersToShow();
    }

</script>
{#if !isUserSelected}
    <h3 class="margin-bottom-16">Utenti</h3>
    <div class="flex-container">
        <Search bind:value={query} placeholder="Cerca per nome, cognome, indirizzo email o settore" /> 
        <Button on:click={() => search()}>Cerca</Button>
    </div>
        <StructuredList condensed>
            <StructuredListHead>
            <StructuredListRow head class="header-row">
                <StructuredListCell head>Email</StructuredListCell>
                <StructuredListCell head>Nome</StructuredListCell>
                <StructuredListCell head>Cognome</StructuredListCell>
                <StructuredListCell head>Tipo di account</StructuredListCell>
                <StructuredListCell head>Building primario</StructuredListCell>
                <StructuredListCell head>Settore primario</StructuredListCell>
                <StructuredListCell head>Azioni</StructuredListCell>
            </StructuredListRow>
            </StructuredListHead>
            <StructuredListBody>
                {#await promise}
                    <InlineLoading />
                {:then}
                    {#if usersToShow.length > 0}
                        {#each usersToShow as user, index}
                        <StructuredListRow class={index%2 === 0 ? "even-row" : ""}>
                            <StructuredListCell>{user.email}</StructuredListCell>
                            <StructuredListCell>{user.firstname}</StructuredListCell>
                            <StructuredListCell>{user.lastname}</StructuredListCell>
                            <StructuredListCell>{Helpers.switchUserType(user.type)}</StructuredListCell>
                            <StructuredListCell>{user.primaryBuilding}</StructuredListCell>
                            <StructuredListCell>{user.primarySector}</StructuredListCell>
                            <StructuredListCell>
                                <Button size="small" kind="ghost" on:click={() => {
                                    userStore.isSelectUser.set(true);
                                    userStore.selectedUser.set(user);
                                }}>Dettagli</Button>
                            </StructuredListCell>
                        </StructuredListRow>
                        {/each} 
                    {:else}
                        <h6 style="margin: 2rem">Nessun utente</h6>
                    {/if}
                {/await}     
            </StructuredListBody>
        </StructuredList>
        <!-- Pagination -->
        <div class="bx--pagination">
            <div class="bx--pagination__left">
                <label id="select-id-pagination-count-label" class="bx--pagination__text" for="select-id-pagination-count">Utenti per pagina:</label>
                <Select class="bx--select bx--select--inline bx--select__item-count" bind:selected={size} on:change={() => {offset = 0; if(tenant) getUsersToShow()}}>
                    <SelectItem value="10" />
                    <SelectItem value="20" />
                    <SelectItem value="50" />
                    <SelectItem value="100" />
                </Select>
                <span class="bx--pagination__text bx--pagination__items-count">{offset + 1 } - {offset + usersToShow.length}</span>
            </div>
            <div class="bx--pagination__right">
                <div class="bx--pagination__control-buttons">
                    <Button 
                        disabled={offset === 0}
                        class="bx--pagination__button bx--pagination__button--backward bx--btn bx--btn--ghost bx--tooltip--hidden bx--btn--icon-only bx--tooltip__trigger bx--tooltip--a11y bx--btn--icon-only--top bx--tooltip--align-center" 
                        icon={CaretLeft16}
                        iconDescription="Indietro"
                        on:click={goBack}
                    />
                    <Button 
                        disabled={isLastPage}
                        class="bx--pagination__button bx--pagination__button--forward bx--btn bx--btn--ghost bx--tooltip--hidden bx--btn--icon-only bx--tooltip__trigger bx--tooltip--a11y bx--btn--icon-only--top bx--tooltip--align-end" 
                        icon={CaretRight16} 
                        iconDescription="Avanti"
                        on:click={goNext}
                    />
                </div>
            </div>
        </div>
    
{:else}
    <Button style="margin-bottom: 2rem;" kind="ghost" iconDescription="Torna agli utenti" icon={ArrowLeft20} on:click={() => {
    userStore.isSelectUser.set(false);
    userStore.selectedUser.set(new UserModel());  
    }} />
    <User requests={requests} />
{/if}

